import Link from 'next/link';
import { ActiveRoute } from '@/lib/helpers';
import DownloadButton from '../DownloadButton';
import {
  corporateDesign,
  forms,
  paasSaas,
  cookieConsent,
} from '@/lib/NavEntrys';
interface MegaMenuProps {
  title: string;
}

const MegaMenu = ({ title }: MegaMenuProps) => {
  return (
    <div className="container-fluid" id="megamenu">
      <div className="container-sm px-0">
        <div className="row pb-5">
          <div className="col-12 pt-4">
            <h1 className="megamenu-heading">{title}</h1>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">Schriften & Farben</h3>
            {corporateDesign.map(([key, value]) => {
              return (
                <Link href={value.link} key={key} legacyBehavior>
                  <a className={ActiveRoute(value.link)} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              );
            })}
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">Formulare</h3>
            {forms.map(([key, value]) => (
              <a
                key={key}
                href={`${process.env.NEXT_PUBLIC_BASE_URL}${value.link}`}
                className={ActiveRoute(value.link)}
                title={value.title}
              >
                {value.title}
              </a>
            ))}
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">PAAS & SAAS-Elemente</h3>
            {paasSaas.map(([key, value]) =>
              key === 'webdienst_header' ? (
                <a
                  key={key}
                  href={`${process.env.NEXT_PUBLIC_BASE_URL}${value.link}`}
                  className={ActiveRoute(value.link)}
                  title={value.title}
                >
                  {value.title}
                </a>
              ) : (
                <Link href={value.link} key={key} legacyBehavior>
                  <a className={ActiveRoute(value.link)} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              )
            )}
          </div>
          <hr className="my-5" />
          <div className="col-12 col-md-12 col-lg-6">
            <h3 className="mt-1 ps-2">Cookie-Hinweis & Datenschutz</h3>
            {cookieConsent.map(([key, value]) => {
              return (
                <Link href={value.link} key={key} legacyBehavior>
                  <a className={ActiveRoute(value.link)} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              );
            })}
          </div>
          <div className="col-12 col-md-12 col-lg-6">
            <h3 className="mt-1 ps-2">Download Package</h3>
            <DownloadButton styles={'btn-primary btn-sm ml-3'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
